export default __webpack_public_path__ + "static/media/arrow_right_big.fc0a5f13.svg";